import { NAME_SOUND_ACTIVE, NAME_SOUND_HOVER, NextSubmitButton, useGameSounds, useMediaQuery, useTranslate } from "@educaplay/core";
import { AnimatePresence, motion } from "framer-motion";
import classes from "./CheckButton.module.scss";
import clsx from 'clsx';
import { Check } from "@educaplay/core/Icons/Check";
import { forwardRef, useEffect } from "react";

export const CheckButton = forwardRef(function CheckButton(props, ref) {
    const { show, answeredQuestion, showSendButton } = props;
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const gameSound = useGameSounds();
    const t = useTranslate();

    useEffect(() => {
        if (!show) return;
        gameSound.play(NAME_SOUND_ACTIVE);
    }, [show, gameSound])

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className={classes.sendButtonContainer}
                    initial={{ y: "100%", opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: "100%", opacity: 0 }}
                >
                    {(isTouchDevice ?
                        <NextSubmitButton
                            showSubmit
                            className={clsx(classes.sendButton, showSendButton && classes.specialpositionmobile)}
                            handleOver={() => gameSound.play(NAME_SOUND_HOVER)}
                        />
                        :
                        <button type={"submit"}
                            className={clsx(classes.sendButtonDesktop, showSendButton && classes.specialposition)}
                            disabled={answeredQuestion}
                            ref={ref}
                            onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}
                        >
                            <Check />
                            {t('common.settings.accept')}
                        </button>
                    )}
                </motion.div>
            )}
        </AnimatePresence>
    )
})